<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardVideo
            :cardContent="content"
            :pathVideoIpad="videoSplit"
            :checkWidth="CheckWidth"
            @nextRoute="nextRoute"
            @returnData="returnData"
          />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardVideo from "../../components/template/Chinese1/CardVideo";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardVideo, LoadingMDL },
  name: "CTV01",
  data() {
    return {
      content: {},
      lang: "",
      baseUrl: process.env.VUE_APP_URL_SOUND,
      videoSplit: "",
      CheckWidth: window.innerWidth,
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: "",
      startTime: "",
      condition: [],
      loading: true,
      nextRoutePath: [],
      conditionRoute: "next",
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      storeLanguage: "language/getLanguage",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
      getCheckAnswerResult: "template/getCheckAnswerResult",
    }),
  },

  watch: {
    allCourse: function(val) {
      if (this.conditionRoute != "next") {
        window.location.reload()
      }
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
        this.splitPaht(val);
      }
    },
    storeLanguage: function(val) {
      this.lang = val;
    },
    getUserTemplate: function(val) {
      this.userTemplateData = val;
      this.condition = [
        {
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        },
      ];
      this.loading = false;
    },
    loadingGetter: function(val) {
      if (val == true) {
        this.$router.push(this.nextAction);
      }
    },
    getCheckAnswerResult: function() {
      if (this.conditionRoute == "go") {   
        this.$router.push(
          "/" + this.nextRoutePath[0] + "/" + this.nextRoutePath[1]
        );
        
      } else if (this.conditionRoute == "returnData") {
        let body = {
          code: this.courseCode,
          templateCode: this.nextRoutePath[0] + "-" + this.nextRoutePath[1],
        };
        this.$store.dispatch("template/fetchContent", body);
        this.$router.push(this.nextRoutePath[1]);
      }
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `CTV01-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
    this.conditionRoute = "next";
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    splitPaht(pathSp) {
      this.videoSplit = pathSp.content.item[0].image;
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    nextRoute(val) {
      this.conditionRoute = "go";
      let str = val.split("-");
      this.nextRoutePath = str;
      this.funcRoute();
    },
    returnData(val) {
      this.conditionRoute = "returnData";
      let str = val.split("-");
      this.nextRoutePath = str;
      this.funcRoute();
    },
    funcRoute() {
      this.loading = true;
      let payload = {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      };
      this.$store.dispatch("template/saveUserTemplateData", payload);
    },
  },
};
</script>
<style></style>
